import { render } from "./StandingsRow.vue?vue&type=template&id=e2e0b764&scoped=true&bindings={\"team\":\"props\",\"statuses\":\"setup\",\"teamClass\":\"setup\",\"teamName\":\"setup\"}"
import script from "./StandingsRow.vue?vue&type=script&lang=ts"
export * from "./StandingsRow.vue?vue&type=script&lang=ts"

import "./StandingsRow.vue?vue&type=style&index=0&id=e2e0b764&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e2e0b764"

export default script